import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-08155c43")

_pushScopeId("data-v-08155c43")
const _hoisted_1 = { class: "analysis-main" }
const _hoisted_2 = { class: "contain flex flex-row" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "question" }
const _hoisted_5 = { class: "div" }
const _hoisted_6 = {
  key: 0,
  class: "score"
}
const _hoisted_7 = { class: "score-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_analysisHeader = _resolveComponent("analysisHeader")
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_question_modules = _resolveComponent("question-modules")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_analysisHeader, {
      name: _ctx.analysis.jobName,
      view: _ctx.view,
      onOnBack: _ctx.goBack
    }, null, 8, ["name", "view", "onOnBack"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "info-dom",
          innerHTML: _ctx.analysis.jobInfomation
        }, null, 8, ["innerHTML"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_a_spin, {
          class: "spin",
          spinning: _ctx.loadings.question
        }, null, 8, ["spinning"]),
        _withDirectives(_createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moduleList, (modules, i) => {
            return (_openBlock(), _createBlock(_component_question_modules, _mergeProps({
              key: modules.id,
              class: "modules"
            }, modules, {
              seq: i+1,
              onReload: _ctx.initQuestion
            }), null, 16, ["seq", "onReload"]))
          }), 128)),
          (_ctx.view === "see")
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.analysis.score || 0) + "分", 1)
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !_ctx.loadings.question]
        ])
      ])
    ])
  ]))
})